import React, { Fragment } from "react";

import { PROJECT_TEAM } from "App/Routes";
import "./MobileProject.css";
import placeholder_team from "images/core/placeholders/placeholder_team.jpg";
import project_image from "images/custom/home/home_graphic.png";
import SidebarLinks from "components/shared/SidebarLinks/SidebarLinks";
import Link from "components/shared/Link/Link";
import MobileProjectPage from "components/Project/MobileProjectPage";

import { SET_PROJECT_BG_IMG } from "config";

class LosDesafiosMobileProjectPage extends MobileProjectPage {
  /* Custom: Los Desafios Image */
  renderLosDesafiosImage() {
    if (!this.props.project.backgroundImage || !SET_PROJECT_BG_IMG) {
      return (
        <div className="mobile-project-losdesafios-image-container">
          <img className="imgresponsive" src={project_image} alt="" />
        </div>
      );
    } else {
      return null;
    }
  }

  renderMobileProjectHome() {
    let name = this.props.user ? this.props.user.name : "";
    let team = this.props.team;
    let teamImage = team && team.image ? team.image : placeholder_team;

    let points =
      this.props.user && this.props.user.points ? this.props.user.points : 0;

    return (
      <div key={"projecthome"} className="pure-u-g mobile-project-main">
        <div className="swipe-to-nav" />
        {/* Custom: Los Desafios image */}
        {this.renderLosDesafiosImage()}
        <div className="mobile-project-sidebar">
          <div className="mobile-project-profile">
            <div className="pure-u-g mobile-project-profile-button-container">
              <div className="pure-u-7-24">
                {this.renderProfileImageLink(name)}
              </div>
              {this.renderMobileProjectInboxIcon()}
              {this.renderMobileProjectNotificationIcon()}
              {this.props.project &&
                this.props.project.teamEnabled &&
                team &&
                team.id && (
                  <div className="pure-u-4-24">
                    <Link
                      to={PROJECT_TEAM.format(this.props.projectId, team.id)}
                    >
                      <span className="square-image-wrapper">
                        <span className="square-image circle mobile-project-profile-button-border">
                          <img src={teamImage} alt="" />
                        </span>
                      </span>
                    </Link>
                  </div>
                )}
            </div>
            <div className="mobile-project-profile-link text-truncated">
              {this.renderProfileNameLink(name)}
            </div>
            <div className="mobile-project-profile-link text-truncated">
              {this.renderProfilePointsLink(points)}
            </div>
          </div>
          <SidebarLinks
            projectId={this.props.project.id}
            showTeams={this.props.project.teamEnabled}
            buttons={this.props.buttons}
            language={this.props.language}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        {this.setBackgroundImage()}
        {this.renderSlider()}
      </Fragment>
    );
  }
}

export default LosDesafiosMobileProjectPage;
